import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full space-y-4" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex space-x-2" }
const _hoisted_4 = { class: "text-md" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " APR ", -1)
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex flex-col items-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " TVL ", -1)
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Fees ", -1)
const _hoisted_14 = { class: "flex flex-col items-end" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Volume (24h) ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_LiquidityAPRTooltip = _resolveComponent("LiquidityAPRTooltip")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (pool, index) => {
      return (_openBlock(), _createBlock(_component_BalCard, {
        key: index,
        onClick: ($event: any) => (_ctx.navigateToPool(pool))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(pool.name), 1),
              _createVNode(_component_BalAssetSet, {
                addresses: pool?.tokens?.map(token => _ctx.getAddress(token.address)),
                width: 100
              }, null, 8, ["addresses"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(Number(pool.apr.swapApr) > 10000 ? '-' : _ctx.fNum(pool.apr.total, 'percent')) + " ", 1),
                  _createVNode(_component_LiquidityAPRTooltip, { pool: pool }, null, 8, ["pool"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.fNum(pool.totalLiquidity, 'usd')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.fNum(pool.swapFee, 'usd')), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.fNum(pool.volume24h, 'usd')), 1)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128))
  ]))
}